/* Cellura Labs NMN landing page interactions */
(function () {
  'use strict';

  var root = document.querySelector('[data-pdp-root]');
  if (!root) return;

  var planInput = root.querySelector('[data-pdp-plan-input]');
  var variantInput = root.querySelector('[data-pdp-variant-id]');
  var ctaLabel = root.querySelector('[data-pdp-cta-label]');
  var cta = root.querySelector('[data-pdp-cta]');
  var stickyPrice = root.querySelector('[data-pdp-sticky-price]');

  var planId = root.dataset.planId || '';
  var subPrice = root.dataset.subPrice || '';
  var otPrice = root.dataset.otPrice || '';

  /* Offer toggle */
  function applyOffer(mode) {
    var isSub = mode === 'sub';
    if (planInput) planInput.value = isSub && planId ? planId : '';
    if (ctaLabel && cta && !cta.disabled) {
      ctaLabel.textContent = isSub
        ? 'Start the 60-Day Challenge — ' + subPrice + '/mo'
        : 'Add to cart — ' + otPrice;
    }
    if (stickyPrice) {
      stickyPrice.textContent = isSub
        ? subPrice + '/mo · 60-day guarantee'
        : otPrice + ' one-time · 60-day guarantee';
    }
  }

  var offers = root.querySelectorAll('[data-pdp-offer]');
  offers.forEach(function (offer) {
    offer.addEventListener('change', function () {
      applyOffer(offer.value);
    });
  });
  var checkedOffer = root.querySelector('[data-pdp-offer]:checked');
  if (checkedOffer) applyOffer(checkedOffer.value);

  /* Quantity */
  var qty = root.querySelector('[data-pdp-qty]');
  var dec = root.querySelector('[data-pdp-qty-dec]');
  var inc = root.querySelector('[data-pdp-qty-inc]');
  if (qty && dec) {
    dec.addEventListener('click', function () {
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
    });
  }
  if (qty && inc) {
    inc.addEventListener('click', function () {
      qty.value = (parseInt(qty.value, 10) || 1) + 1;
    });
  }

  /* Gallery: swipeable track, thumbs jump to a slide, swiping updates the active thumb */
  var track = root.querySelector('[data-pdp-track]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));

  function setActiveThumb(index) {
    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-on', i === index);
    });
    var active = thumbs[index];
    if (active && active.scrollIntoView) {
      active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
  }

  if (track) {
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var slide = track.children[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActiveThumb(i);
      });
    });

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var index = Math.round(track.scrollLeft / track.clientWidth);
          index = Math.max(0, Math.min(track.children.length - 1, index));
          if (thumbs.length) setActiveThumb(Math.min(index, thumbs.length - 1));
        }, 90);
      },
      { passive: true }
    );
  }

  /* Variant selects */
  var selects = root.querySelectorAll('[data-pdp-option]');
  var variants = window.CelluraVariants || [];
  if (selects.length && variants.length) {
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var chosen = {};
        selects.forEach(function (s) {
          chosen[s.dataset.pdpOption] = s.value;
        });
        var match =
          variants.find(function (v) {
            return (
              v.option1 === chosen[1] &&
              (!chosen[2] || v.option2 === chosen[2]) &&
              (!chosen[3] || v.option3 === chosen[3])
            );
          }) || variants[0];
        if (match && variantInput) variantInput.value = match.id;
        if (match && cta) {
          cta.disabled = !match.available;
          if (!match.available && ctaLabel) ctaLabel.textContent = 'Sold out';
          if (match.available) {
            var checked = root.querySelector('[data-pdp-offer]:checked');
            applyOffer(checked ? checked.value : 'sub');
          }
        }
      });
    });
  }

  /* Sticky bar — show after scrolling past the hero buy box */
  var sticky = root.querySelector('[data-pdp-sticky]');
  var hero = document.getElementById('pdp-buy');
  if (sticky && hero && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-shown', !entry.isIntersecting);
          sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      },
      { threshold: 0 }
    );
    io.observe(hero);
  }

  /* Smooth-scroll CTAs back to the buy box */
  root.querySelectorAll('a[href="#pdp-buy"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* Visual storytelling: reveal charts/diagrams/cards when scrolled into view */
  var vizzes = root.querySelectorAll('[data-viz]');
  if (vizzes.length && 'IntersectionObserver' in window) {
    var vizObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-inview');
            vizObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );
    vizzes.forEach(function (el) {
      vizObserver.observe(el);
    });
  } else {
    vizzes.forEach(function (el) {
      el.classList.add('is-inview');
    });
  }
})();
